// src/utils/timeUtils.js

export const formatTimeJST = (date) => {
  return new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: 'Asia/Tokyo',
  }).format(date).replace(',', '');
};

const DEBUG_TIME = (process.env.REACT_APP_DEBUG_TIME || '0') === '1';

export const getActiveSubPlanWithIndex = (subPlans) => {
  const now = new Date();

  // Convert current time to JST
  const nowJST = new Date(
    now.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })
  );

  // nowJST holds JST wall-clock time in the browser's local zone, so toISOString()
  // would shift it back to UTC (the previous day before 09:00 JST for a JST browser).
  const currentDateStr = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now);

  for (let i = 0; i < subPlans.length; i++) {
    const plan = subPlans[i];

    const isDateInRange =
      plan.start_date <= currentDateStr && currentDateStr <= plan.end_date;

    const [startHour, startMinute] = plan.start_time.split(':').map(Number);
    const [endHour, endMinute] = plan.end_time.split(':').map(Number);

    const planStart = new Date(nowJST);
    planStart.setHours(startHour, startMinute, 0, 0);

    const planEnd = new Date(nowJST);
    planEnd.setHours(endHour, endMinute, 0, 0);

    const isTimeInRange = nowJST >= planStart && nowJST <= planEnd;

    if (DEBUG_TIME) {
      console.log(`🔍 Checking SubPlan ${i}`);
      console.log(`📅 Date range: ${plan.start_date} to ${plan.end_date}`);
      console.log(`⏰ Time range: ${plan.start_time} to ${plan.end_time}`);
      console.log(`📍 Now JST: ${nowJST.toISOString()}`);
      console.log(`✅ Date match: ${isDateInRange}`);
      console.log(`✅ Time match: ${isTimeInRange}`);
    }

    if (isDateInRange && isTimeInRange) {
      return { plan, index: i };
    }
  }

  return { plan: null, index: -1 };
};
